Librarian.InputWindow = new Class({
    Extends: Librarian.Window,

    options: {
        id: "InputWindow",
        title: '',
        message: null,
        minimizable: false,
        height: 170,
        width: 350,
        initialValue: '',
        buttonLabel: '',
        textArea: true,
        inputHeight: null,
        maxLength: null,
        messageRequired: false
    },

    onSubmit: null,
    onCancel: null,

    initialize: function (options) {
        this.setOptions(options);

        if (options) {
            this.onSubmit = options.onSubmit;
            this.onCancel = options.onCancel;
        }

        this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/input.html";

        this.parent(this.options);
    },

    onWindowLoaded: function () {
        this.setupElements();

        var messageEl = this.getElement("message");
        if (messageEl && this.options.message) {
            messageEl.set("html", this.options.message);
        }

        if (this.options.textArea)
            var inputEl = this.getElement("inputArea");
        else
            var inputEl = this.getElement("inputText");

        if (inputEl) {
            inputEl.show();

            Librarian.Utils.setElementValue(inputEl, this.options.initialValue || '');
            if (this.options.inputHeight) {
                inputEl.setStyle("height", this.options.inputHeight);
            }

            this.resize({
                height: this.contentEl.getHeight(),
                width: this.options.width
            });

            // Focus the input box so that it's convenient for the user
            if (inputEl.isVisible())
                inputEl.focus();
        }

        var okButtonEl = this.getElement("okButton");
        if (okButtonEl) {
            var label = (this.options.buttonLabel || '');
            if (label.length > 0)
                Librarian.Utils.setElementValue(okButtonEl, label);

            okButtonEl.addOnClick(function () {
                if (this.options.maxLength && (inputEl.value.length > this.options.maxLength)) {
                    Librarian.Utils.error(Librarian.Lang.getArgString("workflow_file_comment_length", [this.options.maxLength]));
                    return;
                }

                if (!this.options.messageRequired || (this.options.messageRequired && inputEl.value.length)) {
                    if (inputEl && typeof this.onSubmit == "function") {
                        this.onSubmit(Librarian.Utils.getElementValue(inputEl));
                    }

                    this.close();
                } else {
                    Librarian.Utils.error(Librarian.Lang.getArgString("workflow_approve_message_required"), inputEl);
                }
            }.bind(this));
        }

        var cancelButtonEl = this.getElement("cancelButton");
        if (cancelButtonEl) {
            cancelButtonEl.addOnClick(function () {
                if (typeof this.onCancel == "function")
                    this.onCancel();

                this.close();
            }.bind(this));
        }
    }
});